export const MAP_UTILITIES_SELECT_MODULE = "MAP_UTILITIES_SELECT_MODULE";
export const MAP_UTILITIES_SHOW_MAP_SETTINGS = "MAP_UTILITIES_SHOW_MAP_SETTINGS";
export const MAP_UTILITIES_SHOW_TAG_APPLIES = "MAP_UTILITIES_SHOW_TAG_APPLIES";